import type { TradingPeriodMessage } from "@cronika/proto/common/trading_pb";
import { FC } from "react";
import { BetForm } from "./components/BetForm";

type BetBlockProps = {
  onTimePeriodChange?: (period: TradingPeriodMessage | undefined) => void;
  onTimePeriodSecondsChange?: (seconds: number | undefined) => void;
  onButtonHover?: (button: "call" | "put" | null) => void;
};

export const BetBlock: FC<BetBlockProps> = ({ onTimePeriodChange, onTimePeriodSecondsChange, onButtonHover }) => (
  <BetForm
    onTimePeriodChange={onTimePeriodChange}
    onTimePeriodSecondsChange={onTimePeriodSecondsChange}
    onButtonHover={onButtonHover}
  />
);
